import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  ADULT_HDF_PATH,
  AGE_SELECTION_PATH,
  CHILD_HDF_PATH,
  EMERGENCY_VISIT_PATH,
  EMERGENCY_VISIT_SUMMARY_PATH,
  EMERGENCY_VISIT_WAIT_TIME_PATH,
  HDF_CONFIRMATION_PATH,
  NHG_HDF_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const EmergencyVisitPage = lazy(() => import('@features/HospitalService/pages/EmergencyVisitPage'));
const HealthDeclarationPage = lazy(
  () => import('@features/HospitalService/pages/HealthDeclarationPage/HealthDeclarationPage')
);
const EmergencyVisitSummaryPage = lazy(
  () => import('@features/HospitalService/pages/EmergencyVisitSummaryPage/EmergencyVisitSummaryPage')
);
const ClinicWaitTimePage = lazy(() => import('@features/HospitalService/pages/ClinicWaitTimePage'));

export const HOSPITAL_SERVICE_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <EmergencyVisitPage />,
    displayTitle: () => 'Emergency Visit',
    pageType: PageType.PRIVATE,
    path: EMERGENCY_VISIT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.emergencyVisit,
  },
  ...[AGE_SELECTION_PATH, ADULT_HDF_PATH, CHILD_HDF_PATH, NHG_HDF_PATH, HDF_CONFIRMATION_PATH].map((path) => ({
    availableViews: [LayoutType.MOBILE],
    component: () => <HealthDeclarationPage />,
    displayTitle: () => 'Find Emergency Departments',
    pageType: PageType.PRIVATE,
    path,
    serviceCatalogCode: SERVICE_CATALOG_CODE.emergencyVisit,
  })),
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <EmergencyVisitSummaryPage />,
    displayTitle: () => 'Emergency Visit',
    pageType: PageType.PRIVATE,
    path: EMERGENCY_VISIT_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.emergencyVisit,
    backUrl: EMERGENCY_VISIT_PATH,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ClinicWaitTimePage />,
    displayTitle: () => 'Wait Time',
    pageType: PageType.PRIVATE,
    path: EMERGENCY_VISIT_WAIT_TIME_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.emergencyVisit,
  },
];
